// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    login: (state, action) => {
      const { data, code } = action.payload;
      state[code] = data;
    },
    updateToken: (state, action) => {
      const { code, token, refresh_token, expire_in } = action.payload;
      if (state[code]) {
        state[code].token = token;
        state[code].refresh_token = refresh_token;
        state[code].expire_in = expire_in;
        state[code].token_issued_at = new Date().toISOString();
      }
    },
    logout: (state, action) => {
      const { code, url } = action.payload;
      state[code] = {};
      state['order'] = {};
      state['admin'] = {};
      state['rx'] = {};
      if ((code === 'admin' || code === 'order') && state?.configuration?.[url])
        delete state?.configuration?.[url];
    },
    clearParticipant: (state, action) => {
      let tempState = {};
      tempState['order'] = state?.['order'];
      tempState['admin'] = state?.['admin'];
      tempState['configuration'] = state?.['configuration'];
      return tempState;
    },
    configuration: (state, action) => {
      const { url, data } = action.payload;
      state.configuration = { ...state.configuration, [url]: data };
    },
    setSelectedOffice: (state, action) => {
      if (state?.admin) state.admin.selected_office = action.payload;
      if (state?.order) state.order.selected_office = action.payload;
      if (state?.rx) state.rx.selected_office = action.payload;
    },
    // Remembered client for SelectClientModal - cleared automatically by `logout` above.
    setSelectedClient: (state, action) => {
      if (state?.admin) state.admin.selected_client_id = action.payload;
    },
  },
});
export const {
  login,
  logout,
  configuration,
  clearParticipant,
  setSelectedOffice,
  updateToken,
  setSelectedClient,
} = authSlice.actions;
export default authSlice.reducer;
